export const CYearsOld = {
  ParentsMinYearsOld: 18,
  TeenMinYearsOld: 0,
  TeenMaxYearsOld: 18,
  TeenUnderAge: 13,
} as const;
